import { ThemeUIStyleObject } from 'theme-ui';

export const containerStyles: ThemeUIStyleObject = {
  paddingBottom: '1rem',
  flexDirection: 'column',
  backgroundColor: 'neutral/000',
};
